import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable, Modal } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  DefaultModal,
  CenteredView,
  ModalView,
  ModalContainer,
  ModalHeader,
  HeaderText,
  ModalContent,
  CancelX,
  BoldText,
} from './elements';
import NewSeller from '../../components/Sellers/new';
import NewContact from '../../components/Contacts/new';
import NewUser from '../../components/Users/AuctionUsers/new';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';

const FilterModal = props => {

  const {
    showModal,
    setShowModal,
    refetch,
    modalType,
    sellerId,
    sellerName,
    clearFilters,
    children
  } = props;
  return (
    <ModalContainer
      onPress={() => setShowModal(false)}
    >
      <DefaultModal
        onRequestClose={() => setShowModal(false)}
        visible={showModal}
        transparent={true}
      >
        <CenteredView>
          <ModalView
            onPress={() => false}
          >
            <ModalHeader>
              <HeaderText>Filter Results</HeaderText>
              <Pressable>
                <CancelX>
                  <FontAwesomeIcon
                    icon={faSquareXmark}
                    size='lg'
                    style={{color: '#fff'}}
                    onClick={() => setShowModal(false)}
                  />
                </CancelX>
              </Pressable>
            </ModalHeader>
            <ModalContent>
              {children}
            </ModalContent>
          </ModalView>
        </CenteredView>
      </DefaultModal>
    </ModalContainer>
  )
}

export default FilterModal;



{/* <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show
      onHide={() => setShowModal(false)}
    >
      <Modal.Header style={filterModalStyle.header}>
        <Modal.Title style={filterModalStyle.title}>
          Filter Results
          <FontAwesomeIcon
            icon={faSquareXmark}
            size='lg'
            style={{color: '#fff'}}
            onClick={() => setShowModal(false)}
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={filterModalStyle.body}>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            style={{
              marginRight: '10px',
              backgroundColor: Colors.elRed,
              border: 'none',
              color: '#000',
              minWidth: '110px'
            }}
            // variant="danger"
            onClick={() => {
              clearFilters();
              setShowModal(false);
            }}
          >
            Reset
          </Button>
          <Button
            style={{
              marginLeft: '10px',
              backgroundColor: Colors.elRed,
              border: 'none',
              color: '#fff',
              minWidth: '110px'
            }}
            // variant="success"
            onClick={() => setShowModal(false)}
          >
            Apply Filters
          </Button>
        </div>
      </Modal.Footer>
    </Modal> */}